import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto mb-4">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-4 font-heading">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-3 text-sm text-foreground-600">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}